import constants from '../Config/constants';
import Env from './env.runtime.native';

declare global {
  interface Window {
    env?: Record<string, string | undefined>;
  }
}

type GetEnvOptions = {
  nativeKey?: string;
  fallback?: string | number | boolean | null;
};

const readProcessEnv = (key: string) => {
  if (typeof process === 'undefined' || !process.env) {
    return undefined;
  }
  return process.env[key];
};

const readWindowEnv = (key: string) => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.env ? window.env[key] : undefined;
};

export const getEnvValue = (key: string, options: GetEnvOptions = {}) => {
  const { nativeKey, fallback } = options;

  if (constants.isWeb) {
    const value = readWindowEnv(key) ?? readProcessEnv(key) ?? Env?.[key];
    return value ?? fallback;
  }

  const resolvedNativeKey = nativeKey || key;
  const value =
    Env?.[resolvedNativeKey] ??
    readProcessEnv(resolvedNativeKey) ??
    Env?.[key] ??
    readProcessEnv(key);

  return value ?? fallback;
};

export const getRazzleEnvValue = (
  key: string,
  options: Omit<GetEnvOptions, 'nativeKey'> = {},
) => {
  const razzleKey = key.startsWith('RAZZLE_') ? key : `RAZZLE_${key}`;
  return getEnvValue(razzleKey, options);
};
